import React, { useCallback, useEffect, useState } from 'react';
import RegionSelectorOutSide from '@/pages/home/components/RegionSelect';
import './index.scss'
import { useLocal } from '@/pages/dashboard/utils/customHook';

interface Props {
  className: string
  value?: {
    regions: string[]
    markets: string[]
    region_type: 'region' | 'market'
  }
  popularList?: string[]
  activeTab?: 'common' | 'popular'
  locale?: 'en-US' | 'zh_CN'
  resultLable?: string[]
  globalDes?: string
  regionCountry?: any[]
  hiddenNoChina?: boolean
  globalMessageHidden?: boolean
  ifDiyPosition?: boolean
  globalMsg?: string
  onTabChange?: (activeTab?: 'common' | 'popular') => void
  onChange?: (value: any) => void
  showDismissIcon?: boolean
}

const ReactSelector = (props: Props) => {
  const {
    className,
    value,
    regionCountry,
    popularList,
    locale,
    globalMsg,
    hiddenNoChina = false,
    globalMessageHidden = false,
    ifDiyPosition = false,
    activeTab = 'common',
    resultLable,
    globalDes,
    onTabChange,
    onChange,
    showDismissIcon,
  } = props;
  const { getLocalText } = useLocal('region_selector')
  const {
    regions,
    markets,
    region_type
  } = value ?? {};
  const hiddenList = ['all areas', 'ALL AREAS', 'global', 'GLOBAL'];

  const handleConfirm = ({ regions, renderList }: any) => {
    let markets: string[] = [];

    renderList?.regions?.map(region => {
      if (region.selectStatus !== 'empty') {
        markets = [
          ...markets,
          ...region.childrenSelectList
        ]
      }
    })

    if (markets?.length === 0) {
      markets = [...(regions ?? [])]
    }

    if (markets[0] === 'global' || markets[0] === 'GLOBAL') {
      markets[0] = '255'
    }

    //数据没有变化,则返回（region的数据转换为markets再作对比）
    if (JSON.stringify(value?.markets) === JSON.stringify(regions)) {
      return
    }
    if ((JSON.stringify(value?.markets) === "[]" || JSON.stringify(value?.markets) === '["255"]')
      && (JSON.stringify(regions) === '["global"]')) {
      return
    }
    const result = {
      regions: [],
      markets: markets?.length > 0 ? markets : ['255'],
      region_type: region_type
    }

    onChange?.(result)
  }
  //国家筛选器选项翻译
  const getLocalRegionList = useCallback((regionList, _locale) => {
    const isCn = _locale === 'zh-CN'
    const _newList = regionList?.map((item) => {
      return {
        ...(item || {}),
        region_name_en: isCn ? item?.region_name_cn : item?.region_name_en,
        country: item.country?.map((item) => {
          return {
            ...(item || {}),
            country_name_en: isCn ? item?.country_name_cn : item?.country_name_en,
          }
        }),
      }
    })
    return _newList
  }, [JSON.stringify(regionCountry)])

  /**修改因为切换翻译时，选择的内容被展示成默认 */
  const regionList = regionCountry?.filter(item => !hiddenList.includes(item?.region_abbre?.toLowerCase()));
  const [regionValue, setRegionValue] = useState(markets)
  useEffect(() => {
    const _regionValue = markets;
    setRegionValue([])
    setTimeout(() => {
      setRegionValue(_regionValue)
    }, 0)
  }, [locale])

  return (
    <RegionSelectorOutSide
      value={regionValue?.[0] === '255' ? ['global'] : regionValue}
      className={className}
      dropdownClassName='region-selector-dropdown'
      region_type='market'
      regionType='market'
      showUnidentified={false}
      globalMsg={globalMsg}
      popularList={popularList?.length ? popularList : ['ru', 'tr', 'us', 'br', 'mx']}
      locale={locale}
      activeTab={activeTab}
      onTabChange={onTabChange}
      showChinese={false}
      globalMessageHidden={globalMessageHidden}
      ifDiyPosition={ifDiyPosition}
      hiddenNoChina={hiddenNoChina}
      regionCountry={getLocalRegionList(regionList, locale)}
      // regionCountry={regionCountry?.filter(item => !hiddenList.includes(item?.region_abbre?.toLowerCase()))}
      globalNodataText={getLocalText('global_no_data_text')}
      unidentifiedNoDataText={getLocalText('global_no_data_text')}
      onConfirm={handleConfirm}
      resultLable={resultLable}
      globalDes={globalDes}
      // popularList={popularList}
      showDismissIcon={showDismissIcon}
    />
  )
}

export default ReactSelector;
